import * as React from "react";
import { Field } from "formik";
import Input from "components/bootstrap/Input";
const NameFormGroup = () => /* @__PURE__ */ React.createElement(Field, { name: "name" }, ({ field: { value, onChange } }) => /* @__PURE__ */ React.createElement(
  Input,
  {
    type: "text",
    id: "name",
    label: "Name",
    required: true,
    onChange,
    help: "The name of the team",
    labelClassName: "col-sm-3",
    wrapperClassName: "col-sm-9",
    value: value != null ? value : ""
  }
));
export default NameFormGroup;
